import axios from 'axios'
import router from '../router';

// 环境地址
// axios.defaults.baseURL = process.env.API_HOST;

// 请求超时时间
axios.defaults.timeout = 5000
// 请求头
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded"
}

// 添加请求拦截器
// axios.interceptors.request.use(
//   config => {
//     // 发送请求前
//     var token = window.localStorage.getItem('token')
//     if(token){
//       config.headers['Authorization'] = `token ${token}`
//     }
//     return config
//   },
//   err => {
//     // 请求错误时
//     return Promise.reject(err)
//   }
// )

// 添加响应拦截器
axios.interceptors.response.use(
  res => {
    // if(res.data.msg == "您的账号已过期或已在别处登陆" && res.data.rescode == 2){
    //   window.localStorage.removeItem('token')
    //   router.push({name: 'Login'})
    //   // window.location.href = 'http://shenjl.cn/protection'
    // }
    return res.data
  },
  err => {
    // 请求错误时
    return Promise.reject(err)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/common/http.js